<div class="content">
    <tailored-widget-editor [actionIntent]="input()" (actionResult)="modalClosureRequested($event)" />
</div>
